/**
 * MobileAppLogo
 * Shown at the top of the login/auth screen on native Android.
 */
import React from 'react';
import { GGJLogoMark } from '../Brand/GGJLogo';

interface MobileAppLogoProps {
  /** Diameter of the visible icon circle in px. Default 96. */
  iconSize?: number;
  /** Show "GoGrabJob" + tagline below the mark. Default true. */
  showTagline?: boolean;
  className?: string;
}

const MobileAppLogo: React.FC<MobileAppLogoProps> = ({
  iconSize = 96,
  showTagline = true,
  className = '',
}) => {
  return (
    <div
      className={`flex flex-col items-center gap-3 ${className}`}
      aria-label="GoGrabJob"
    >
      <GGJLogoMark size={iconSize} className="shadow-[0_8px_24px_rgba(0,0,0,0.30)]" />

      <h1
        className="m-0 font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white"
        style={{ fontSize: Math.round(iconSize * 0.26) }}
      >
        GoGrabJob
      </h1>

      {showTagline && (
        <p
          className="m-0 text-center text-[13px] font-normal text-[var(--vscode-text-secondary,#616161)]"
        >
          AI-powered job search companion
        </p>
      )}
    </div>
  );
};

export default MobileAppLogo;
